import { render, staticRenderFns } from "./PPC1.vue?vue&type=template&id=2e18c7d8&scoped=true&"
import script from "./PPC1.vue?vue&type=script&lang=js&"
export * from "./PPC1.vue?vue&type=script&lang=js&"
import style0 from "./PPC1.vue?vue&type=style&index=0&id=2e18c7d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18c7d8",
  null
  
)

export default component.exports